import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { MailX, CheckCircle2, Loader2, AlertTriangle } from "lucide-react";

import api from "../../services/api";

// Página pública — se abre desde el link del correo, sin sesión. Autorización:
// el token opaco en la URL, nunca un login (mismo patrón que
// AppointmentConfirm/InvoiceReceipt).

const EmailUnsubscribe = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [email, setEmail] = useState("");
  const [alreadyUnsubscribed, setAlreadyUnsubscribed] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const loadInfo = async () => {
      try {
        const { data } = await api.get(
          `/public/email-marketing/unsubscribe/${token}`
        );
        setEmail(data.email);
        setAlreadyUnsubscribed(data.alreadyUnsubscribed);
      } catch (err) {
        setError(true);
      }
      setLoading(false);
    };
    loadInfo();
  }, [token]);

  const handleConfirm = async () => {
    setConfirming(true);
    try {
      await api.post(`/public/email-marketing/unsubscribe/${token}`);
      setDone(true);
    } catch (err) {
      setError(true);
    }
    setConfirming(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950 px-4">
      <div className="w-full max-w-sm bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-slate-200 dark:border-slate-800 p-6 text-center">
        {loading ? (
          <Loader2 className="w-8 h-8 text-indigo-500 animate-spin mx-auto" />
        ) : error ? (
          <>
            <AlertTriangle className="w-10 h-10 text-amber-500 mx-auto mb-3" />
            <p className="text-base font-semibold text-slate-800 dark:text-slate-100">
              Este link ya no es válido
            </p>
            <p className="text-sm text-slate-500 mt-1">
              Puede que ya haya expirado o que el enlace esté incompleto.
            </p>
          </>
        ) : done || alreadyUnsubscribed ? (
          <>
            <CheckCircle2 className="w-10 h-10 text-emerald-600 mx-auto mb-3" />
            <p className="text-base font-semibold text-slate-800 dark:text-slate-100">
              Ya no recibirás más correos
            </p>
            <p className="text-sm text-slate-500 mt-1">
              {email} fue dado de baja de nuestras campañas de correo.
            </p>
          </>
        ) : (
          <>
            <MailX className="w-10 h-10 text-slate-400 mx-auto mb-3" />
            <p className="text-base font-semibold text-slate-800 dark:text-slate-100">
              ¿Darte de baja?
            </p>
            <p className="text-sm text-slate-500 mt-1 mb-4">
              Dejarás de recibir correos de campaña en <strong>{email}</strong>.
            </p>
            <button
              onClick={handleConfirm}
              disabled={confirming}
              className="w-full flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-semibold bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50 transition-colors"
            >
              {confirming && <Loader2 className="w-4 h-4 animate-spin" />}
              Confirmar baja
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default EmailUnsubscribe;
